export default __webpack_public_path__ + "static/media/417hz-release-the-past.df7e5820.ogg";